<template>
    <div class="sw-modal confirm-dialog">
        <div v-click-outside="cancelAction" v-on:click.stop="" class="sw-modal-content">
            <div class="row sw-modal-heading">
                <div class="col">
                    <h4>Turn Automation <span class="text-uppercase">{{turnOnOrOff}}</span></h4>
                </div>
            </div>
            <div class="sw-modal-body">
                <div v-if="!showPreview" class="row confirm-dialog__detail confirm-dialog__detail--question">
                    <div class="col-12">
                        Are you sure you want to <b>turn {{turnOnOrOff}}</b> the Automation <b>{{automation.name}}?</b>
                    </div>
                </div>
                <div v-if="showPreview" class="row confirm-dialog__detail confirm-dialog__detail--question">
                    <div class="col">
                        <div class="alert alert-info">
                            <i class="fas fa-info-circle"></i>
                            <b> Automations</b> create Tasks<br><b>Tasks</b> do the actual communicating
                        </div>
                    </div>
                </div>

                <div v-if="!showPreview" class="row confirm-dialog__detail">
                    <div class="col-12 text-right text-note">
                        Advanced <input type="checkbox" v-model="showAdvanced">
                    </div>
                </div>

                <template v-if="!showPreview && showAdvanced">
                    <template v-if="automation.active">
                        <div class="row confirm-dialog__detail">
                            <div class="col-2">
                                <input type="checkbox" v-model="pauseTasks">
                            </div>
                            <div class="col-10">
                                <h6>Pause future Tasks</h6>
                                <span class="text-note">
                                    Pause all scheduled Tasks created by this Automation
                                </span>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <div class="row confirm-dialog__detail">
                            <div class="col-2">
                                <input type="checkbox" v-model="unPauseTasks">
                            </div>
                            <div class="col-10">
                                <h6>Un-pause Tasks</h6>
                                <span class="text-note">
                                Un-pause Tasks created by this Automation
                                <ul>
                                    <li>scheduled to take place in the future</li>
                                    <li>that are currently paused</li>
                                </ul>
                            </span>
                            </div>
                        </div>
                        <div class="row confirm-dialog__detail">
                            <div class="col-2">
                                <input type="checkbox" v-model="createMissingTasks">
                            </div>
                            <div class="col-10">
                                <h6>Create missing Tasks</h6>
                                <span class="text-note">
                                Create Tasks for existing Bookings where:
                                <ul>
                                    <li>a Task of this type does not exist</li>
                                    <li>those Tasks would have been scheduled for future execution</li>
                                </ul>
                            </span>
                            </div>
                        </div>
                    </template>
                </template>

                <div v-if="showPreview" class="row confirm-dialog__detail">
                    <div v-if="waiting" class="col-12 text-center">
                        Finding affected Bookings...
                    </div>

                    <template v-else>

                        <template v-if="automation.active">
                            <div class="col-12 mb-3">
                                <h5>Pause Tasks for Bookings</h5>
                                <div class="confirm-dialog__preview-bookings">
                                    <table class="confirm-dialog__preview-bookings-table">
                                        <thead v-if="toggleResult.taskPausedFor.length > 0">
                                        <th class="confirm-dialog__preview-bookings-table__checkbox">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="pauseAllToggle" v-model="pauseAll" ref="pauseAllToggle">
                                                <label class="custom-control-label" for="pauseAllToggle"></label>
                                            </div>
                                        </th>
                                        <th class="confirm-dialog__preview-bookings-table__arrival">Arrival</th>
                                        <th>Guest</th>
                                        </thead>
                                        <tr v-for="(booking, index) in toggleResult.taskPausedFor" v-bind:key="index">
                                            <td><input type="checkbox" v-model="booking.selected" v-on:change="checkAllToPauseCheckboxState"></td>
                                            <td>{{friendlyDate(booking.arrival)}}</td>
                                            <td>{{booking.bookedBy.firstName}} {{booking.bookedBy.lastName}}</td>
                                        </tr>
                                        <tr v-if="toggleResult.taskPausedFor.length === 0">
                                            <td colspan="3" class="text-center">There are no Tasks to pause</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </template>

                        <template v-else>

                            <div v-if="createMissingTasks" class="col-12 mb-3">
                                <h5>Create Tasks for Bookings</h5>
                                <div class="confirm-dialog__preview-bookings">
                                    <table class="confirm-dialog__preview-bookings-table">
                                        <thead v-if="toggleResult.taskCreatedFor.length > 0">
                                        <th class="confirm-dialog__preview-bookings-table__checkbox">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="createAllMissingToggle" v-model="createAllMissing" ref="createAllMissingToggle">
                                                <label class="custom-control-label" for="createAllMissingToggle"></label>
                                            </div>
                                        </th>
                                        <th class="confirm-dialog__preview-bookings-table__arrival">Arrival</th>
                                        <th>Guest</th>
                                        </thead>
                                        <tr v-for="(booking, index) in toggleResult.taskCreatedFor" v-bind:key="index">
                                            <td><input type="checkbox" v-model="booking.selected" v-on:change="checkAllToCreateCheckboxState"></td>
                                            <td>{{friendlyDate(booking.arrival)}}</td>
                                            <td>{{booking.bookedBy.firstName}} {{booking.bookedBy.lastName}}</td>
                                        </tr>
                                        <tr v-if="toggleResult.taskCreatedFor.length === 0">
                                            <td colspan="3" class="text-center">There are no Bookings without this Task</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <div v-if="unPauseTasks" class="col-12 mb-3">
                                <h5>Un-pause Tasks for Bookings</h5>
                                <div class="confirm-dialog__preview-bookings">
                                    <table class="confirm-dialog__preview-bookings-table">
                                        <thead v-if="toggleResult.taskUnPausedFor.length > 0">
                                        <th class="confirm-dialog__preview-bookings-table__checkbox">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="unPauseAllToggle" v-model="unPauseAll" ref="unPauseAllToggle">
                                                <label class="custom-control-label" for="unPauseAllToggle"></label>
                                            </div>
                                        </th>
                                        <th class="confirm-dialog__preview-bookings-table__arrival">Arrival</th>
                                        <th>Guest</th>
                                        </thead>
                                        <tr v-for="(booking, index) in toggleResult.taskUnPausedFor" v-bind:key="index">
                                            <td><input type="checkbox" v-model="booking.selected" v-on:change="checkAllToUnPauseCheckboxState"></td>
                                            <td>{{friendlyDate(booking.arrival)}}</td>
                                            <td>{{booking.bookedBy.firstName}} {{booking.bookedBy.lastName}}</td>
                                        </tr>
                                        <tr v-if="toggleResult.taskUnPausedFor.length === 0">
                                            <td colspan="3" class="text-center">There are no Tasks to un-pause</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <div class="col-12 confirm-dialog__preview-bookings-past text-note">
                                Include past events for current bookings? <input type="checkbox" v-model="includePastEvents" v-on:change="previewAction()">
                            </div>

                        </template>
                    </template>

                </div>

                <div v-if="error" class="text-error">
                    {{infoMessage}}
                </div>

                <div class="sw-modal-actions">
                    <div v-if="waiting">
                        <Spinner/>
                    </div>
                    <div v-else class="row">
                        <div class="col text-center">
                            <button class="btn btn-normal" v-on:click.stop="cancelAction()">Cancel</button>
                            <button v-if="!showPreview && (createMissingTasks || pauseTasks || unPauseTasks)" class="btn btn-primary" v-on:click.stop="previewAction()">Preview</button>
                            <button class="btn" v-bind:class="{'btn-primary': showPreview, 'btn-secondary' : !showPreview}" v-on:click.stop="continueAction()">Turn {{turnOnOrOff}}</button>
                        </div>
                    </div>
                    <div v-if="!showPreview" class="row mt-3">
                        <div class="col text-note">
                            We recommend you <b>preview</b> before turning on
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Spinner from '../Spinner.vue'
    import {datesMixin} from '../../mixins/DatesMixin'
    import {store} from '../../store.js'

    export default {
        name: 'ConfirmToggleAutomationDialog',
        components: {Spinner},
        mixins: [datesMixin],
        props: {
            automation: Object,
            callbackName: String,
            callbackReference: String,
            errorMessage: String,
            show: Boolean
        },
        data: function() {
            return {
                canCancel: false,
                showAdvanced: false,
                showPreview: false,
                includePastEvents: false,
                createMissingTasks: false,
                pauseTasks: false,
                unPauseTasks: false,
                createAllMissing: true,
                createSomeMissing: false,
                pauseAll: true,
                pauseSome: false,
                unPauseAll: true,
                unPauseSome: false,
                waiting: false,
                error: false,
                infoMessage: null,
                toggleResult: null
            }
        },
        computed: {
            turnOnOrOff: function() {
                if (this.automation.active) {
                    return 'off';
                } else {
                    return 'on';
                }
            }
        },
        watch: {
            pauseAll: {
                handler: function () {
                    if (this.pauseAll) {
                        this.toggleAllBookingsInList(this.toggleResult.taskPausedFor, true);
                    } else {
                        this.toggleAllBookingsInList(this.toggleResult.taskPausedFor, false);
                    }
                    this.pauseSome = false;
                }
            },
            createAllMissing: {
                handler: function () {
                    if (this.createAllMissing) {
                        this.toggleAllBookingsInList(this.toggleResult.taskCreatedFor, true);
                    } else {
                        this.toggleAllBookingsInList(this.toggleResult.taskCreatedFor, false);
                    }
                    this.createSomeMissing = false;
                }
            },
            unPauseAll: {
                handler: function () {
                    if (this.unPauseAll) {
                        this.toggleAllBookingsInList(this.toggleResult.taskUnPausedFor, true);
                    } else {
                        this.toggleAllBookingsInList(this.toggleResult.taskUnPausedFor, false);
                    }
                    this.unPauseSome = false;
                }
            },
        },
        methods: {
            cancelAction: function() {
                if (this.canCancel) {
                    console.log("cancel");
                    this.$root.$emit(this.callbackName);
                }
            },
            previewAction: async function() {
                this.showPreview = true;
                if (this.automation.active) {
                    await this.fetchTogglePreview(false, true, false, false);
                } else {
                    await this.fetchTogglePreview(true, false, this.unPauseTasks, this.createMissingTasks);
                }
            },
            fetchTogglePreview: async function(turnOn, pauseTasks, unPauseTasks, createMissingTasks) {
                this.waiting = true;
                let body = {
                    "reference": this.automation.reference,
                    "turnOn": turnOn,
                    "onlyFutureExecution": !this.includePastEvents,
                    "createMissingTasks": createMissingTasks,
                    "pauseTasks": pauseTasks,
                    "unPauseTasks": unPauseTasks,
                };

                console.log(body);

                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/automations/' + this.automation.reference + "/togglePreview";

                try {
                    const result = await this.$http.put(url, body);
                    this.toggleResult = result.data;
                    this.toggleAllBookingsInAllLists(true);
                    console.log("Fetched preview of toggling");
                    console.log(this.toggleResult);
                } catch (error) {
                    this.error = true;
                    this.infoMessage = "Error loading preview";
                    this.toggleResult = null;
                }
                this.waiting = false;
            },
            toggleAllBookingsInAllLists: function(selected) {
                this.toggleAllBookingsInList(this.toggleResult.taskCreatedFor, selected);
                this.toggleAllBookingsInList(this.toggleResult.taskPausedFor, selected);
                this.toggleAllBookingsInList(this.toggleResult.taskUnPausedFor, selected);
            },
            toggleAllBookingsInList: function(list, selected) {
                if (list) {
                    for (let booking of list) {
                        booking.selected = selected;
                    }
                }
            },
            checkIfAllInListInSameState: function(list, state) {
                for (const booking of list) {
                    if (booking.selected != state) {
                        return false;
                    }
                }
                return true;
            },
            checkAllToCreateCheckboxState: function(event) {
                let isChecked = event.target.checked;
                let wholeListSameState = this.checkIfAllInListInSameState(this.toggleResult.taskCreatedFor, isChecked);
                if (!wholeListSameState) {
                    this.$refs.createAllMissingToggle.indeterminate = true;
                    this.createSomeMissing = true;
                } else {
                    this.$refs.createAllMissingToggle.indeterminate = false;
                    if (isChecked) {
                        this.createAllMissing = true;
                    } else {
                        this.createAllMissing = false;
                    }
                    this.createSomeMissing = false;
                }
            },
            checkAllToPauseCheckboxState: function(event) {
                let isChecked = event.target.checked;
                let wholeListSameState = this.checkIfAllInListInSameState(this.toggleResult.taskPausedFor, isChecked);
                if (!wholeListSameState) {
                    console.log("XXX");
                    this.$refs.pauseAllToggle.indeterminate = true;
                    this.pauseSome = true;
                } else {
                    this.$refs.pauseAllToggle.indeterminate = false;
                    if (isChecked) {
                        this.pauseAll = true;
                    } else {
                        this.pauseAll = false;
                    }
                    this.pauseSome = false;
                }
            },
            checkAllToUnPauseCheckboxState: function(event) {
                let isChecked = event.target.checked;
                let wholeListSameState = this.checkIfAllInListInSameState(this.toggleResult.taskUnPausedFor, isChecked);
                if (!wholeListSameState) {
                    this.$refs.unPauseAllToggle.indeterminate = true;
                    this.unPauseSome = true;
                } else {
                    this.$refs.unPauseAllToggle.indeterminate = false;
                    if (isChecked) {
                        this.unPauseAll = true;
                    } else {
                        this.unPauseAll = false;
                    }
                    this.unPauseSome = false;
                }
            },
            getBookingRefsFromList: function(list) {
                let refs = [];
                for (const booking of list) {
                    if (booking.selected) {
                        refs.push(booking.reference);
                    }
                }
                return refs;
            },
            continueAction: function() {
                this.waiting = true;

                let creating = this.createMissingTasks;
                let bookingRefsToCreateTasksFor = null;
                if (creating && this.showPreview) {
                    if (this.createSomeMissing) {
                        bookingRefsToCreateTasksFor = this.getBookingRefsFromList(this.toggleResult.taskCreatedFor);
                    } else if (this.getBookingRefsFromList(this.toggleResult.taskCreatedFor).length === 0) {
                        creating = false;
                    }
                }

                let pausing = this.pauseTasks;
                let bookingRefsToPauseTasksFor = null;
                if (pausing && this.showPreview) {
                    if (this.pauseSome) {
                        bookingRefsToPauseTasksFor = this.getBookingRefsFromList(this.toggleResult.taskPausedFor);
                    } else if (this.getBookingRefsFromList(this.toggleResult.taskPausedFor).length === 0) {
                        pausing = false;
                    }
                }

                let unPausing = this.unPauseTasks;
                let bookingRefsToUnPauseTasksFor = null;
                if (unPausing && this.showPreview) {
                    if (this.unPauseSome) {
                        bookingRefsToUnPauseTasksFor = this.getBookingRefsFromList(this.toggleResult.taskUnPausedFor);
                    } else if (this.getBookingRefsFromList(this.toggleResult.taskUnPausedFor).length === 0) {
                        unPausing = false;
                    }
                }

                this.$root.$emit(this.callbackName,
                    this.callbackReference,
                    !this.automation.active,
                    !this.includePastEvents,
                    creating,
                    bookingRefsToCreateTasksFor,
                    pausing,
                    bookingRefsToPauseTasksFor,
                    unPausing,
                    bookingRefsToUnPauseTasksFor);
            },
        },
        mounted() {
            if (this.automation.active) {
                this.pauseTasks = true;
            } else {
                this.createMissingTasks = true;
                this.unPauseTasks = true;
            }
            setTimeout(() => {
                this.canCancel = true;
            }, 500);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal.scss";
    @import "../../styles/components/confirm_dialog.scss";
</style>